import { withTranslation } from 'react-i18next';
import ActiveProcessInstanceTable from './ActiveProcessInstanceTable';

export default withTranslation('pages')(ActiveProcessInstanceTable);
